import React, { useState, useContext } from 'react';

import UserContext from 'contexts/UserContext';
import Course from 'containers/Administrator/Users/Create_Old/Teacher/Courses/Course';
import Add from 'containers/Administrator/Users/Create_Old/Teacher/Courses/Add';
import Button from 'components/Button';

const Courses = () => {
	// Use user's context
	const { user } = useContext(UserContext);

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<h2>Moduļi ({user.courses?.length})</h2>

			{/* Teacher's courses */}
			{!!user.courses?.length && <div className="teacherCourses withMarginTop">
				{user.courses?.map(course =>
					<Course key={course.id} course={course} />
				)}
			</div>}
			
			{/* Toggle course selection modal */}
			<Button
				block
				icon="add"
				theme="light"
				text="Pievienot moduli"
				className="withMarginTop"
				onClick={handleModal}
			/>

			{/* Course selection modal */}
			<Add modal={modal} handleModal={handleModal} />
		</>
	);
};

export default Courses;